import merge from 'lodash/merge';
import {environment} from './Environments/environment';

export function extendConfiguration() {
  return new Promise((resolve, reject) => {
    function loadAndApplyConfig() {
      const httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = () => {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
          if (httpRequest.status === 200) {
            const environmentSettings = JSON.parse(httpRequest.responseText);
            merge(environment, environmentSettings);
            resolve({});
          } else {
            reject(
                new Error('there was a problem with loading the environment settings'),
            );
          }
        }
      };
      httpRequest.open('GET', 'settings.json');
      httpRequest.send();
    }

    loadAndApplyConfig();
  });
}
